import { compose } from "@reduxjs/toolkit";
import { memo } from "react";
import StepEditor from "./StepEditor";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
    templates: state.landingPages.templates,
    isLandingPageFormLoading: state.landingPages.isLandingPageFormLoading,

    customSources: state.landingPages.customSources,
});

const mapDispatchToProps = (dispatch): any => ({});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(memo(StepEditor));
